import { createWebHistory, createRouter } from "vue-router";
import Experience from "@/views/Experience.vue";
import Login from "@/views/Login.vue";
import NotFound from "@/views/NotFound.vue";
import store from './store'

const routes = [
  {
    path: "/",
    name: "Experience",
    component: Experience,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// GOOD
router.beforeEach((to, from, next) => {
  console.log(store);
  if (to.name !== 'Login' && !store.state.isAuthenticated) next({ name: 'Login' })
  else next()
})

// const authGuard = (to, from, next) => {
//   console.log(store.isAuthenticated)
//   if (store.isAuthenticated) {
//     next();
//   } else {
//     next("/login")
//   }
// };

export default router;